import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'post-chip-dd',
    templateUrl: './post-chip-dd.component.html',
    styleUrls: ['./post-chip-dd.component.scss'],
    standalone: false
})
export class PostChipDdComponent implements OnInit {

  constructor() { }

  @Input() chipList:string[] = [];
  ngOnInit(): void {
  }


  public dragstart_handler(event: any) {
    let value = event.target.dataset.dragData;
    
    
    event.dataTransfer.setData('text/plain', value);
    
  }
}
